import { render, staticRenderFns } from "./seikyu-list.vue?vue&type=template&id=67bb6901&scoped=true&"
import script from "./seikyu-list.vue?vue&type=script&lang=js&"
export * from "./seikyu-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bb6901",
  null
  
)

export default component.exports